import React, { useMemo } from 'react'
import { useReservation } from '../../../../store'

import './FixedScheduleComplete.scss'

// 선택한 메뉴명 표기 (앞의 ①/② 번호는 제외)
const menuMark = menu => (menu
	? menu.replace(/^[①-⑳]\s*/, '')
	: '미선택')

// 비회원 결제 시 세션에서 복원한 추가정보는 JSON 문자열로 저장되어 있어 배열로 변환
const toInfoList = (infos) => {
	try {
		const parsed = typeof infos === 'string'
			? JSON.parse(infos)
			: infos
		return Array.isArray(parsed)
			? parsed
			: []
	} catch (e) {
		return []
	}
}

// 고정 일정 매장의 예약 완료 요약 (행사·일정·참석자별 점심 메뉴)
export default function FixedScheduleComplete({ schedule }) {
	const { name, totalPartySize, additionalInfos } = useReservation()
	const { detail, complete } = schedule
	// 예약 조회 API는 매장에 등록된 추가정보만 내려주므로(동반인 항목 제외) 결제 직전 세션 정보로 보완
	const holdingInfos = useMemo(() => {
		try {
			return toInfoList(JSON.parse(sessionStorage.getItem('tablemanagerHoldings') || '{}').additionalInfos)
		} catch (e) {
			return []
		}
	}, [])
	const infos = toInfoList(additionalInfos)
	const valueOf = itemName => infos.find(item => item.name === itemName)?.value
		?? holdingInfos.find(item => item.name === itemName)?.value

	const attendees = [
		`${name || '예약자'} - ${menuMark(valueOf(detail.menuItemName))}`,
		...Array.from({ length: Math.max(totalPartySize - 1, 0) }, (_, idx) => {
			const guestName = valueOf(`동반인${idx + 1} 성함`) || `동반인 ${idx + 1}`
			return `${guestName} - ${menuMark(valueOf(`동반인${idx + 1} 점심 메뉴`))}`
		}),
	]

	return (
		<div className="fixed-schedule-complete">
			<div className="icon">✓</div>
			<h3>예약이 완료되었습니다.</h3>
			<dl className="summary">
				<dt>행사</dt>
				<dd>{schedule.title}</dd>
				<dt>일정</dt>
				<dd>{schedule.dateText} · {totalPartySize}명</dd>
				<dt>참석자 및 메뉴</dt>
				<dd>
					{attendees.map((attendee, idx) => <div key={idx}>{attendee}</div>)}
				</dd>
			</dl>
			<div className="notes">
				{complete.notes.map(note => <p key={note}>{note}</p>)}
			</div>
		</div>
	)
}
